import { render, staticRenderFns } from "./confirmation.vue?vue&type=template&id=5b495d04"
import script from "./confirmation.vue?vue&type=script&lang=js"
export * from "./confirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\web\\rcms\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b495d04')) {
      api.createRecord('5b495d04', component.options)
    } else {
      api.reload('5b495d04', component.options)
    }
    module.hot.accept("./confirmation.vue?vue&type=template&id=5b495d04", function () {
      api.rerender('5b495d04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/callback/confirmation.vue"
export default component.exports